import { graphql } from "~/gql";

export const UPDATE_TECHNOLOGY_CHARGE = graphql(/* GraphQL */ `
  mutation updateTechnologyCharge($technologyCharge: UpdateTechnologyChargeInput!) {
    updateTechnologyCharge(technologyCharge: $technologyCharge) {
      ...TechnologyChargeParts
    }
  }
`);

export const UPDATE_TECHNOLOGY_CHARGES = graphql(/* GraphQL */ `
  mutation updateTechnologyCharges($data: [UpdateTechnologyChargeInput!]!) {
    updateTechnologyCharges(data: $data) {
      ...TechnologyChargeParts
    }
  }
`);
